export const openLeftSidebarAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_LEFT_SIDEBAR',
		payload: e
	})
}

export const openRightSidebarAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_RIGHT_SIDEBAR',
		payload: e
	})
}

export const openSettingbarAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_SETTING_BAR',
		payload: e
	})
}

export const authMenuAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_AUTH_MENU',
		payload: e
	})
}
export const languageMenuAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_LANGUAGE_MENU',
		payload: e
	})
}
export const profileMenuAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_PROFILE_MENU',
		payload: e
	})
}
export const toggle3DotMenuAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_3DOT_MENU',
		payload: e
	})
}
export const dropDownMenuAction = (e) => dispatch => {
	dispatch({
		type: 'TOGGLE_DROPDOWN_MENU',
		payload: e
	})
}